var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSkipForward = function SvgSkipForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.362 20.877c.22.318.432.477.636.477a.738.738 0 0 0 .587-.416c.178-.272.272-.591.27-.917v-6.935c0-.293-.16-.44-.478-.44-.185 0-.368.037-.538.11l-2.52 1.137c-.383.18-.574.384-.574.612.022.164.085.32.183.452.188.294.384.44.587.44a.491.491 0 0 0 .196-.048l1.443-.66v5.687c.024.182.095.355.208.501Zm9.032-6.351c.254.687.377 1.417.36 2.15v.648c0 1.694-.529 2.955-1.466 3.58a2.985 2.985 0 0 1-4.408-1.429 5.598 5.598 0 0 1-.373-2.15v-.65c0-1.694.541-2.954 1.478-3.591a2.883 2.883 0 0 1 1.646-.469 2.845 2.845 0 0 1 2.763 1.91Zm-1.274 2.246c0-1.742-.492-2.607-1.489-2.607-.997 0-1.49.865-1.49 2.607v.456c0 1.742.493 2.607 1.49 2.607s1.49-.864 1.49-2.607v-.456Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M27 17a11 11 0 1 1-22 0c0-6.075 5-11 12-11h8m0 0-3-3m3 3-3 3"
  })));
};
export default SvgSkipForward;